import { React } from 'react';
import {
  LegendContainer,
  LabelStyle,
  GreenColorStyle,
  OrangeColorStyle,
  LegendTextStyle,
  RowStyle,
  FlagImage,
  GapColorStyle,
  MissedText,
  LegendTextCollapsStyle,
  LabelCollapsedStyle,
  LegendCollapsContainer,
} from '../../../atoms/sidebar/sidebar.styles';
import { formatNumberWithKAndM } from '../../../../util/commonUtil';
import { useRecoilValue } from 'recoil';
import { Recoil_Quarter_State, SidebarExpandCollapseState } from '../../../../recoil/recoil';
import {
  QUARTERLY_DETAILS,
  MONTH_QUARTER_STATUS,
  PERIOD,
  FORECAST_SIDEBAR_QUARTER_CONST,
} from '../../../../constants/commonConstants';

const Legend = ({ quarterlyData, quarterText, flagImageSrc, quarterTitle }) => {
  const quarterInfo = useRecoilValue(Recoil_Quarter_State);
  const sidebarExpandState = useRecoilValue(SidebarExpandCollapseState);
  let data = quarterlyData;
  let soldValue = quarterlyData?.sold;
  let commitValue = quarterlyData?.commit;
  let forecastedValue = quarterlyData?.forecast;
  let gapValue;

  if(forecastedValue<0) // here forecasted value in -ve case was not handled go gap value was not being updated
    forecastedValue = 0;

  if (!!data && data.period == PERIOD.PAST) {
    if (
      quarterInfo.current_month_start_date == quarterInfo.quarter_start_date ||
      quarterInfo.current_month_end_date == quarterInfo.quarter_end_date ||
      (quarterInfo.current_month_start_date > quarterInfo.quarter_start_date &&
        quarterInfo.current_month_start_date < quarterInfo.quarter_end_date)
    ) {
      //current
      gapValue = Math.abs(forecastedValue - commitValue - soldValue);
    } else {
      //past
      gapValue = Math.abs(forecastedValue - soldValue);
      commitValue = 0;
    }
  } else {
    //future
    gapValue = Math.abs(forecastedValue - commitValue - soldValue);
  }

  const getValue = (value, caption) => {
    if (data?.valid_quarter === false) {
      return QUARTERLY_DETAILS.NOT_APPLICABLE;
    } else if (
      (caption === QUARTERLY_DETAILS.GAP || caption === QUARTERLY_DETAILS.FORECAST) &&
      data?.tag === MONTH_QUARTER_STATUS.NOT_APPLICABLE
    ) {
      return QUARTERLY_DETAILS.NOT_APPLICABLE;
    } else {
      return formatNumberWithKAndM(value) || 0;
    }
  };

  return (
    <>
      {!!data && (
        <>
          {sidebarExpandState ? (
            <LegendContainer aria-live="polite">
              <LabelStyle>
                <span>{getValue(data?.sold, QUARTERLY_DETAILS.WON)}</span>

                <RowStyle>
                  <GreenColorStyle />
                  <LegendTextStyle>{QUARTERLY_DETAILS.WON}</LegendTextStyle>
                </RowStyle>
              </LabelStyle>

              {data.period != PERIOD.PAST ||
                (quarterText == quarterInfo.quarter &&
                  data?.selected_year == quarterInfo.fiscal_year && (
                    <LabelStyle>
                      <span>{getValue(data?.commit, QUARTERLY_DETAILS.COMMIT)}</span>

                      <RowStyle>
                        <OrangeColorStyle />
                        <LegendTextStyle>{QUARTERLY_DETAILS.COMMIT}</LegendTextStyle>
                      </RowStyle>
                    </LabelStyle>
                  ))}

              <LabelStyle>
                <span>{getValue(gapValue, QUARTERLY_DETAILS.GAP)}</span>

                <RowStyle>
                  <GapColorStyle />
                  <LegendTextStyle>{QUARTERLY_DETAILS.GAP}</LegendTextStyle>
                </RowStyle>
              </LabelStyle>
              <LabelStyle>
                <span>
                  <span>
                    {getValue(data?.forecast, QUARTERLY_DETAILS.FORECAST)}

                    {data?.tag == MONTH_QUARTER_STATUS.MISSED && (
                      <MissedText> ({QUARTERLY_DETAILS.MISSED})</MissedText>
                    )}
                  </span>
                </span>
                <RowStyle>
                  <FlagImage src={flagImageSrc} alt=" " />
                  <LegendTextStyle>{QUARTERLY_DETAILS.FORECAST}</LegendTextStyle>
                </RowStyle>
              </LabelStyle>
            </LegendContainer>
          ) : (
            <LegendCollapsContainer>
              {quarterTitle == FORECAST_SIDEBAR_QUARTER_CONST.NOW && (
                <LabelCollapsedStyle>
                  <RowStyle>
                    <LegendTextCollapsStyle>Won</LegendTextCollapsStyle>
                  </RowStyle>
                  <span>{formatNumberWithKAndM(data?.sold) || 0}</span>
                </LabelCollapsedStyle>
              )}

              {quarterTitle == FORECAST_SIDEBAR_QUARTER_CONST.NOW && (
                <LabelCollapsedStyle>
                  <RowStyle>
                    <LegendTextCollapsStyle>{QUARTERLY_DETAILS.COMMIT}</LegendTextCollapsStyle>
                  </RowStyle>
                  <span>{formatNumberWithKAndM(data?.commit) || 0}</span>
                </LabelCollapsedStyle>
              )}

              {quarterTitle == FORECAST_SIDEBAR_QUARTER_CONST.NOW && (
                <LabelCollapsedStyle>
                  <RowStyle>
                    <LegendTextCollapsStyle>{QUARTERLY_DETAILS.GAP}</LegendTextCollapsStyle>
                  </RowStyle>
                  <span>{formatNumberWithKAndM(gapValue) || 0}</span>
                </LabelCollapsedStyle>
              )}

              {quarterTitle == FORECAST_SIDEBAR_QUARTER_CONST.NOW && (
                <LabelCollapsedStyle>
                  <RowStyle>
                    <LegendTextCollapsStyle>{QUARTERLY_DETAILS.FORECAST}</LegendTextCollapsStyle>
                  </RowStyle>
                  <span>
                    <span>
                      {formatNumberWithKAndM(data?.forecast) || 0}
                      {data?.tag == MONTH_QUARTER_STATUS.MISSED && (
                        <MissedText> ({QUARTERLY_DETAILS.MISSED})</MissedText>
                      )}
                    </span>
                  </span>
                </LabelCollapsedStyle>
              )}

              {quarterTitle === FORECAST_SIDEBAR_QUARTER_CONST.NEXT && (
                <LabelCollapsedStyle>
                  <RowStyle>
                    <LegendTextCollapsStyle>{QUARTERLY_DETAILS.PROJECTED}</LegendTextCollapsStyle>
                  </RowStyle>
                  <span>{formatNumberWithKAndM(data?.commit) || 0}</span>
                </LabelCollapsedStyle>
              )}

              {quarterTitle == FORECAST_SIDEBAR_QUARTER_CONST.BEYOND && (
                <LabelCollapsedStyle>
                  <RowStyle>
                    <LegendTextCollapsStyle>{QUARTERLY_DETAILS.PROJECTED}</LegendTextCollapsStyle>
                  </RowStyle>
                  <span>{formatNumberWithKAndM(data?.commit) || 0}</span>
                </LabelCollapsedStyle>
              )}
            </LegendCollapsContainer>
          )}
        </>
      )}
    </>
  );
};

export default Legend;
